/* eslint-disable react/jsx-props-no-spreading,camelcase */
import React, { useContext, useRef } from 'react';

const AdsContext = React.createContext();

const AdsProvider = (props) => {
  const adsPositionsRef = useRef([]);

  const getPosition = ({ containerId, type }) => {
    const positionIndex = adsPositionsRef.current.findIndex((i) => i.containerId === containerId);
    let position;

    if (positionIndex !== -1) {
      position = adsPositionsRef.current[positionIndex].position;
    } else {
      const count = adsPositionsRef.current.filter((i) => i.type === type).length;
      position = count + 1;
      adsPositionsRef.current.push({
        type,
        containerId,
        position,
      });
    }

    return position;
  };

  return <AdsContext.Provider value={{ getPosition }} {...props} />;
};

const useAds = () => {
  const context = useContext(AdsContext);
  if (context === undefined) {
    throw new Error('useAds must be used within a AdsProvider');
  }
  return context;
};

export { AdsProvider, useAds };
